import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import GetQrLink from "./getQrLink";
export { GetQrLink };

export const BookingAPI = async (data) => {
  const bookingData = { ...data, type: "50" };
  const response = await axios.post(
    `/booking/ajax/${data.id === null ? "new" : `edit/${data.id}`}`,
    bookingData
  );
  return response.data;
};

export const FetchBookingData = createAsyncThunk(
  "FetchBookingData",
  async (id) => {
    let response = null;
    let qrTitle = "";
    let adsCategories = "";
    try {
      const { data } = await axios.get(`/booking/${id}/get`);
      qrTitle = data.data.titleQr;
      adsCategories = data.data.categories;
      response = data.data;
    } catch (error) {
      throw new Error(error.response.status);
    }

    return {
      ...response,
      qrTitle,
      adsCategories,
    };
  }
);
